import React, { useState } from 'react';
import { ExternalLink, Star, Download } from 'lucide-react';
import { formatPrice, resolveImageUrl } from '../../lib/utils';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import LeadCaptureModal from '../common/LeadCaptureModal';

export const ProductCard = ({ product }) => {
  const {
    id, name, description, price, currency, image_url, external_link,
    category, is_featured, is_free, is_lead_gated, file_url,
  } = product;

  const [showLeadModal, setShowLeadModal] = useState(false);

  const handlePrimary = (e) => {
    if (is_lead_gated) {
      e.preventDefault();
      setShowLeadModal(true);
    } else if (is_free && file_url) {
      // direct download for free non-gated
      // (let the anchor handle it)
    }
  };

  const primaryHref = is_lead_gated
    ? '#'
    : is_free && file_url
      ? resolveImageUrl(file_url)
      : external_link || '#';

  const primaryLabel = is_lead_gated
    ? 'Baixar Grátis'
    : is_free
      ? 'Download'
      : 'Comprar';

  const PrimaryIcon = is_free || is_lead_gated ? Download : ExternalLink;

  return (
    <>
      <div
        className="group bg-white border border-[#D6D2C4] rounded-sm overflow-hidden card-hover flex flex-col"
        data-testid={`product-card-${id}`}
      >
        <div className="aspect-[4/3] relative overflow-hidden">
          <img
            src={resolveImageUrl(image_url) || 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=800&q=80'}
            alt={name}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          {is_featured && (
            <Badge className="absolute top-3 right-3 bg-[#DFAF3A] text-[#1A1A1A] font-['Montserrat'] text-[10px] uppercase tracking-wider">
              <Star size={10} className="mr-1" fill="currentColor" />
              Destaque
            </Badge>
          )}
          <Badge className="absolute top-3 left-3 bg-[#0F5A34] text-white font-['Montserrat'] text-[10px] uppercase tracking-wider">
            {category}
          </Badge>
        </div>

        <div className="p-4 flex flex-col flex-1">
          <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#1A1A1A] mb-2 line-clamp-2 group-hover:text-[#0F5A34] transition-colors">
            {name}
          </h3>
          <p className="text-[#5C5C5C] font-['Inter'] text-sm mb-4 line-clamp-3 flex-1">
            {description}
          </p>

          <div className="flex items-center justify-between gap-3 mt-auto">
            <span className={`font-['Montserrat'] text-xl font-bold ${is_free ? 'text-[#E53935]' : 'text-[#0F5A34]'}`}>
              {is_free ? 'GRÁTIS' : formatPrice(price, currency)}
            </span>
            <a
              href={primaryHref}
              onClick={handlePrimary}
              target={is_lead_gated || is_free ? '_self' : '_blank'}
              rel="noopener noreferrer"
              data-testid={`product-cta-${id}`}
            >
              <Button
                className={`${is_free || is_lead_gated ? 'bg-[#0F5A34] hover:bg-[#0c4628]' : 'bg-[#E53935] hover:bg-[#C62828]'} text-white font-['Montserrat'] text-sm`}
              >
                {primaryLabel}
                <PrimaryIcon size={14} className="ml-2" />
              </Button>
            </a>
          </div>
        </div>
      </div>

      {is_lead_gated && (
        <LeadCaptureModal
          open={showLeadModal}
          product={product}
          onClose={() => setShowLeadModal(false)}
        />
      )}
    </>
  );
};

export default ProductCard;
